import { createAction, props } from "@ngrx/store";
import { ODataResponse, ODataParams } from "@tdw/core";
import { FittingProduct, FittingsAdminFilter, FittingAssociatedProduct, FittingProductAssociatedProduct, ClosureAdminFilter } from "src/app/models";
import { ProductConfiguration, FittingDetail } from "src/app/models/fitting-query-params.model";

const loadFittings = createAction('[Admin] Load Fittings');
const loadFittingsSuccess = createAction('[Admin] Load Fittings Success', props<{ fittings: ODataResponse<FittingProduct[]> }>());
const loadFittingsFail = createAction('[Admin] Load Fittings Fail', props<{ error: any }>());

const loadFittingsForPage = createAction('[Admin] Load Fittings for page', props<{ page: number }>());
const loadConfigurationsForPage = createAction('[Admin] Load Configurations for page', props<{ page: number }>());

const loadConfigurations = createAction('[Admin] Load Configurations');
const loadConfigurationsSuccess = createAction('[Admin] Load Configurations Success', props<{ configurations: ODataResponse<ProductConfiguration[]> }>());
const loadConfigurationsFail = createAction('[Admin] Load Configurations Fail', props<{ error: any }>());

const saveProductConfiguration = createAction('[Admin] Save Product Configuration', props<{ configuration: ProductConfiguration }>());
const saveProductConfigurationSuccess = createAction('[Admin] Save Product Configuration Success');
const saveProductConfigurationFail = createAction('[Admin] Save Product Configuration Fail', props<{ error: any }>());

// const loadAvailableProducts = createAction('[Admin] Load Available Products', props<{ q: ODataParams }>());
// const loadAvailableProductsSuccess = createAction('[Admin] Load Available Products Success', props<{ Products: ODataResponse<AvailableConfiguration[]> }>());
// const loadAvailableProductsFail = createAction('[Admin] Load Available Products Fail', props<{ error: any }>());

const changeFilterValue = createAction('[Admin] change filter value', props<{ key: 'suffix' | 'productNumber' | 'productLine' | 'isActive', value: string | boolean | undefined }>());
const updateFittingsAdminFilter = createAction('[Admin] update fittings admin filter value', props<{ obj: FittingsAdminFilter }>());
const updateClosuresAdminFilter = createAction('[Admin] update closures admin filter value', props<{ obj: ClosureAdminFilter }>());

const saveFittingRecord = createAction('[ADMIN] save fitting record', props<{ fittingProduct: FittingProduct }>());
const saveFittingRecordSuccess = createAction('[ADMIN] save fitting record success');
const saveFittingRecordFail = createAction('ADMIN save fitting record fail', props<{ error: any }>());

const loadCurrentlyEditingFitting = createAction('[admin] load editing fitting', props<{ fittingId?: number }>());
const loadCurrentlyEditingFittingSuccess = createAction('[admin] load editing fitting success', props<{ fitting: FittingProduct | null }>());
const loadCurrentlyEditingFittingFail = createAction('[admin] load editing fitting fail', props<{ error: any }>());

const loadCurrentlyEditingAssociatedProducts = createAction('[admin] load editing associatedProducts', props<{ id: number }>());
const loadCurrentlyEditingAssociatedProductsSuccess = createAction('[admin] load editing associatedProducts success', props<{ associatedProducts: FittingAssociatedProduct[] }>());
const loadCurrentlyEditingAssociatedProductsFail = createAction('[admin] load editing associatedProducts fail', props<{ error: any }>());

const loadFittingProductAssociatedProducts = createAction('[admin] load fittingproductAssociatedProducts', props<{ q: ODataParams }>());
const loadFittingProductAssociatedProductsSuccess = createAction('[admin] load fittingproductassociatedproducts success', props<{ res: ODataResponse<FittingProductAssociatedProduct[]> }>());
const loadFittingProductAssociatedProductsFail = createAction('[admin] load fittingproductassocaitedproducts fail', props<{ error: any }>());

const addFittingDesignCode = createAction('[admin] add a fitting design code', props<{ fittingId: number, designCodeId: number }>());
const addFittingDesignCodeSuccess = createAction('[admin] add a fitting design code success', props<{ fittingDetail: FittingDetail }>());
const addFittingDesignCodeFail = createAction('[admin] add a fitting design code fail', props<{ error: any }>());

const removeFittingDesignCode = createAction('[admin] remove a fitting design code', props<{ fittingProductDesignCodeId: number }>());
const removeFittingDesignCodeSuccess = createAction('[admin] remove a fitting design code success');
const removeFittingDesignCodeFail = createAction('[admin] remove a fitting design code fail', props<{ error: any }>());

const addFittingDesignPressure = createAction('[admin] add fitting design pressure', props<{ maxPressure: number, designFactorId: number, fittingId: number }>());
const addFittingDesignPressureSuccess = createAction('[admin] add fitting design pressure success');
const addFittingDesignPressureFail = createAction('[admin] add fitting design pressure fail', props<{ error: any }>());

const removeFittingDesignPressure = createAction('[admin] remove fitting design pressure', props<{ fittingProductDesignPressureId: number }>());
const removeFittingDesignPressureSuccess = createAction('[admin] remove fitting design pressure success');
const removeFittingDesignPressureFail = createAction('[admin] remove fitting design pressure fail', props<{ error: any }>());

const queryAssociatedProducts = createAction('[admin] queryAssociatedProducts', props<{ q: string }>());
const queryAssociatedProductsSuccess = createAction('[admin] queryAssociatedProducts success', props<{ products: FittingAssociatedProduct[] }>());
const queryAssociatedProductsFail = createAction('[admin] queryAssociatedProducts fail', props<{ error: any }>());

const addAssociatedProduct = createAction('[Admin] add associated product', props<{ associateProductId: number, fittingId: number }>());
const addAssociatedProductSuccessful = createAction('[Admin] add associated product success');
const addAssociatedProductFail = createAction('[Admin] add associated product fail', props<{ error: any }>());

const removeAssociatedProduct = createAction('[Admin] remove associated product', props<{ associatedProductId: number }>());
const removeAssociatedProductSuccess = createAction('[Admin] remove associated product success');
const removeAssociatedProductFail = createAction('[Admin] remove associated product fail', props<{ error: any }>());


export const FITTINGS = {
  loadFittings,
  loadFittingsSuccess,
  loadFittingsFail,
  loadFittingsForPage,
  loadConfigurationsForPage,
  loadConfigurations,
  loadConfigurationsSuccess,
  loadConfigurationsFail,
  saveProductConfiguration,
  saveProductConfigurationSuccess,
  saveProductConfigurationFail,
  // loadAvailableProducts,
  // loadAvailableProductsSuccess,
  // loadAvailableProductsFail,
  changeFilterValue,
  updateFittingsAdminFilter,
  updateClosuresAdminFilter,
  saveFittingRecord,
  saveFittingRecordSuccess,
  saveFittingRecordFail,
  loadCurrentlyEditingFitting,
  loadCurrentlyEditingFittingSuccess,
  loadCurrentlyEditingFittingFail,
  loadCurrentlyEditingAssociatedProducts,
  loadCurrentlyEditingAssociatedProductsSuccess,
  loadCurrentlyEditingAssociatedProductsFail,
  loadFittingProductAssociatedProducts,
  loadFittingProductAssociatedProductsSuccess,
  loadFittingProductAssociatedProductsFail,
  addFittingDesignCode,
  addFittingDesignCodeSuccess,
  addFittingDesignCodeFail,
  removeFittingDesignCode,
  removeFittingDesignCodeSuccess,
  removeFittingDesignCodeFail,
  addFittingDesignPressure,
  addFittingDesignPressureSuccess,
  addFittingDesignPressureFail,
  removeFittingDesignPressure,
  removeFittingDesignPressureSuccess,
  removeFittingDesignPressureFail,
  queryAssociatedProducts,
  queryAssociatedProductsSuccess,
  queryAssociatedProductsFail,
  addAssociatedProduct,
  addAssociatedProductSuccessful,
  addAssociatedProductFail,
  removeAssociatedProduct,
  removeAssociatedProductSuccess,
  removeAssociatedProductFail
}
